/**
 * Dependencies.
 */
import de from './de.translate';
import el from './el.translate';
import en from './en.translate';
import es from './es.translate';
import fi from './fi.translate';
import fr from './fr.translate';
import it from './it.translate';
import pl from './pl.translate';
import pt from './pt.translate';

/**
 * Export.
 */
export default {
  'de-DE': { PRODUCTS_OFFERED: de },
  'el-GR': { PRODUCTS_OFFERED: el },
  'en-US': { PRODUCTS_OFFERED: en },
  'es-ES': { PRODUCTS_OFFERED: es },
  'fi-FI': { PRODUCTS_OFFERED: fi },
  'fr-FR': { PRODUCTS_OFFERED: fr },
  'it-IT': { PRODUCTS_OFFERED: it },
  'pl-PL': { PRODUCTS_OFFERED: pl },
  'pt-PT': { PRODUCTS_OFFERED: pt }
};
